import Highcharts from "highcharts";
import { FONT_COLORS } from "../../../constants";
import { formatCurrency } from "../../../helpers";
import {
  CHART_LABEL_FONT_SIZE,
  CHART_SERIES,
  CHARTS_SHARED_OPTIONS,
  SeriesNames,
} from "../../../constants/charts";

export const PRICE_CHART_DEFAULT_OPTIONS: Highcharts.Options = {
  ...CHARTS_SHARED_OPTIONS,
  chart: {
    ...CHARTS_SHARED_OPTIONS.chart,
    height: 200,
  },
  legend: {
    ...CHARTS_SHARED_OPTIONS.legend,
    padding: 4,
    itemDistance: 8,
  },
  yAxis: [
    {
      title: {
        text: "",
      },
      labels: {
        x: -4,
        style: {
          fontSize: CHART_LABEL_FONT_SIZE,
          color: FONT_COLORS.label,
        },
        formatter: ({ value }) =>
          formatCurrency(value, undefined, {
            maximumFractionDigits: 0,
          }),
      },
    },
    // This is a secondary y-axis (hidden) reserved as a placeholder
    {
      title: {
        text: "",
      },
      labels: {
        enabled: false,
      },
    },
    // This is a third y-axis used for displaying Sales Rank data on the right
    {
      opposite: true,
      title: {
        text: "",
      },
      labels: {
        x: 4,
        style: {
          fontSize: CHART_LABEL_FONT_SIZE,
          color: FONT_COLORS.label,
        },
        formatter: ({ value }) =>
          +value >= 1000 ? `${+value / 1000}k` : String(value),
      },
    },
  ],
  series: [
    {
      ...CHART_SERIES[SeriesNames.Amazon],
      type: "area",
      fillColor: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, "#FEE2C5"],
          [1, "#FEEFE0"],
        ],
      },
      marker: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      states: {
        hover: {
          lineWidth: 1,
        },
        inactive: {
          opacity: 1,
        },
      },
    },
    {
      ...CHART_SERIES[SeriesNames.FBA],
      type: "line",
      marker: {
        symbol: "triangle",
      },
    },
    {
      ...CHART_SERIES[SeriesNames.FBM],
      type: "line",
      marker: {
        symbol: "square",
      },
    },
    {
      ...CHART_SERIES[SeriesNames.BuyBox],
      type: "line",
      marker: {
        symbol: "diamond",
      },
    },
    {
      ...CHART_SERIES[SeriesNames.New],
      type: "line",
    },
    {
      ...CHART_SERIES[SeriesNames.SalesRank],
      type: "line",
      yAxis: 2, // Uses the third y-axis (right side) for displaying Sales Rank data
    },
  ],
};
